import React, { FC } from 'react';

import { recordCategoriesSelectors } from '../../../redux/ducks/recordCategories';
import { useRecordDetailsQuery } from '../../../redux/ducks/recordDetails';
import BaseRecords from '../baseRecords';

const RegularSeasonCoachRecords: FC = () => {
    const recordCategory = recordCategoriesSelectors.recordCategoryIdByDescription('coach-records');
    const { data: coachRecords = [], isFetching } = useRecordDetailsQuery(recordCategory, {
        skip: recordCategory === null,
    });
    return (
        <BaseRecords
            isLoading={isFetching}
            records={coachRecords}
            templateKey="RECORDS_COACH"
            options={{
                registry: {
                    link: '/registry/head-coach-regular-season',
                    heading: 'All-Time Head Coach Register',
                },
            }}
        />
    );
};

export { RegularSeasonCoachRecords as Component };
export default RegularSeasonCoachRecords;
